var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svgicon",class:{ scale: !!_vm.width || !!_vm.height },style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }